import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

export default function CookieBanner() {
    const { t } = useLanguage();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("cookie-consent");
        if (!consent) {
            const timer = setTimeout(() => setIsVisible(true), 2000);
            return () => clearTimeout(timer);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem("cookie-consent", "true");
        setIsVisible(false);
    };

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    className="fixed bottom-24 left-6 right-6 md:bottom-8 md:left-8 md:right-auto md:max-w-sm z-[200]"
                >
                    <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl border border-gray-100 dark:border-gray-800 p-5 md:p-6 backdrop-blur-xl bg-opacity-95 dark:bg-opacity-95">
                        <div className="flex items-start gap-4">
                            <div className="p-3 bg-indigo-50 dark:bg-indigo-900/30 rounded-xl shrink-0">
                                <Cookie className="w-6 h-6 text-indigo-500" />
                            </div>
                            <div className="flex-1">
                                <h3 className="text-sm font-bold text-gray-900 dark:text-gray-100 mb-1">
                                    {t('cookie_title')}
                                </h3>
                                <p className="text-xs text-gray-500 dark:text-gray-400 leading-relaxed mb-4">
                                    {t('cookie_desc')}
                                </p>
                                <div className="flex items-center gap-3">
                                    <button
                                        onClick={acceptCookies}
                                        className="px-5 py-2 bg-brand-gradient text-white text-xs font-bold rounded-lg shadow-lg shadow-indigo-500/20 hover:opacity-90 transition-opacity"
                                    >
                                        {t('cookie_action')}
                                    </button>
                                    <Link
                                        to="/privacy"
                                        className="text-xs text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 underline"
                                    >
                                        {t('cookie_read_more')}
                                    </Link>
                                </div>
                            </div>
                            <button 
                                onClick={() => setIsVisible(false)}
                                className="p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                            >
                                <X className="w-4 h-4" />
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
